import React from 'react'
import PageContainer from 'components/Onboarding/PageContainer/PageContainer'
import {
  BaseComponent,
  Loader
} from 'belle-js'
import { handleError } from 'utils/apiErrorHandler'
import { beneficiaryTypes } from 'utils/contactUtils'
import { removeNullData } from 'utils/formFieldLists'
import { allContactTypes } from 'utils/contactTypes'
import styles from './ContactForm.module.scss'

const withContactIndexForm = (FormComponent) => {
  class ContactForm extends BaseComponent {

    constructor (props) {
      super(props)
      const {
        description,
      } = props

      this.state = {
        isLoadingPage: false,
        description,
      }
      this.bind(
        'onSuccess',
        'submitForm',
        'handleOnDeleteContact',
        'handleOnAddContact',
        'handleOnCreateContact'
      )
    }

    onSuccess (data) {
      const {
        editFinancialAccount,
        goNextSection,
        editContactFinancialAccountRole,
        addContactFinancialAccountRole,
        removeContactFinancialAccountRole,
      } = this.props

      if (data) {
        const {
          financialAccount,
          updatedContactRoles,
          deletedContactRoleIds,
          newContactRoles
        } = data

        financialAccount && editFinancialAccount(financialAccount)

        if (deletedContactRoleIds) {
          deletedContactRoleIds.map(id => removeContactFinancialAccountRole(id))
        }
        newContactRoles && newContactRoles.map(r => addContactFinancialAccountRole(r))
        updatedContactRoles && updatedContactRoles.map(r => editContactFinancialAccountRole(r))
      }

      goNextSection && goNextSection()
    }

    onFailure (error) {
      handleError(error)
    }

    handleOnAddContact (params) {
      const {
        goAddContactRoute,
        financialAccountId,
        contactType,
        financialAccountType,
      } = this.props
      const beneficiaryType = contactType === 'beneficiaries' ? params.beneficiaryType : null

      if (goAddContactRoute) {
        goAddContactRoute({
          financialAccountId,
          contactType,
          financialAccountType,
          beneficiaryType
        })
      }
    }

    async handleOnCreateContact (params) {
      const {
        handleCreateContactRole,
        addContactFinancialAccountRole
      } = this.props

      this.setState({ isLoadingPage: true })
      const role = await handleCreateContactRole(params)

      addContactFinancialAccountRole(role)
      this.setState({ isLoadingPage: false })
    }

    async handleOnDeleteContact (contactId) {
      const {
        handleDeleteContactRole,
        removeContactFinancialAccountRole
      } = this.props

      this.setState({ isLoadingPage: true })
      const roleId = await handleDeleteContactRole(contactId)

      removeContactFinancialAccountRole(roleId)
      this.setState({ isLoadingPage: false })
    }

    contactsGroupedByNumber (formData) {
      const {
        contacts,
        currentFinancialAccountContacts,
        role,
      } = this.props
      const roleContacts = currentFinancialAccountContacts.filter(e => e.role === role)

      const contactsGrouped = Object
        .keys(formData)
        .reduce((contactsGroupAcc, propName) => {
          let propValue = formData[propName]
          const beneficiaryFormTypes = [beneficiaryTypes.CONTINGENT, beneficiaryTypes.PRIMARY]
          const contactKeyMatch = propName.match(/(contact_\d)_(.*)_(.*)?/)
          const [, contactNumber] = contactKeyMatch
          let [, , propType, formType] = contactKeyMatch

          let newContactsGrouped = {}
          formType = formType === 'Default' ?
            beneficiaryTypes.PRIMARY : beneficiaryTypes.CONTINGENT

          if (propType === 'name') {
            propType = 'data'
            propValue = contacts.find(c => c.name === propValue)
          }

          const formTypeExists = contactsGroupAcc[formType]
          let contactNumberProperties = {}
          if (formTypeExists) {
            contactNumberProperties = { ...contactsGroupAcc[formType][contactNumber] }
          }
          newContactsGrouped = {
            ...contactsGroupAcc,
            [formType]: {
              ...contactsGroupAcc[formType],
              [contactNumber]: {
                ...contactNumberProperties,
                [propType]: propValue,
                formType: beneficiaryFormTypes.includes(formType) ? formType : null
              }
            },

          }
          return newContactsGrouped
        }, {})
      return this.updateContactsWithRoleData(contactsGrouped, roleContacts)
    }

    updateContactsWithRoleData (contactsGrouped, roleContacts) {
      return Object.values(contactsGrouped)
        .reduce((acc, c) => ([...Object.values(c), ...acc]), [])
        .map((contact) => {
          const roleContactInfo = roleContacts.find(r => r.id === contact.data.id)
          if (roleContactInfo) {
            return {
              ...contact,
              data: roleContactInfo
            }
          }
          return contact
        })
    }

    getModifiedContacts (contactsFromRoles) {
      return contactsFromRoles.filter(c =>
        c.data.sharePercentage !== undefined && c.percentage !== c.data.sharePercentage)
    }

    getContactsToBeDeleted (adHocContacts, unMaskedModifiedContacts) {
      return adHocContacts.filter(adHocContact => (
        !unMaskedModifiedContacts.find(e => (e.data.id === adHocContact.id))
      ))
    }

    getNewAdHocContacts (adHocContacts, unMaskedModifiedContacts) {
      return unMaskedModifiedContacts.filter(modifiedContact => (
        !adHocContacts.find(t => (t.id === modifiedContact.data.id))
      ))
    }

    removeRadioFields (formData) {
      return Object.keys(formData)
        .filter(f => f.match(/(contact_\d)_(.*)_(.*)?/))
        .reduce((acc, key) => ({ ...acc, [key]: formData[key] }), {})
    }

    async submitForm (formData) {
      const {
        updateAccount,
        contactType,
      } = this.props
      const result = {}
      const hasContacts = Object.keys(formData).length > 0
      let sanitizedFormData = removeNullData(formData)
      sanitizedFormData = this.removeRadioFields(sanitizedFormData)
      const beneficiaryType = allContactTypes.beneficiaries.routeType
      const isBeneficiaryForm = contactType === beneficiaryType

      this.setState({ isLoadingPage: true })

      if (hasContacts) {
        const {
          adHocContacts,
          handleCreateContactRole,
          handleDeleteContactRole,
          handleUpdateContactRole,
          isSuccessorDonor,
        } = this.props

        /** If contacts are masked, i.e contacts like: Lia Skalkos (1), Lia Skalkos,
         *  we need to get the information for both Lias */
        const contactsGrouped = this.contactsGroupedByNumber(sanitizedFormData)
        const newadHocContacts = this.getNewAdHocContacts(adHocContacts, contactsGrouped)
        const contactsToDelete = this.getContactsToBeDeleted(adHocContacts, contactsGrouped)
        const contactsToUpdate = isBeneficiaryForm ? this.getModifiedContacts(contactsGrouped) : []
        const deleteContactHandler = async c => handleDeleteContactRole(c.id)
        const addContactHandler = async c => handleCreateContactRole({
          contactId: c.data.id,
          sharePercentage: isSuccessorDonor ? 100 : c.percentage,
          beneficiaryType: c.formType
        })
        const updateContactHandler = async c => handleUpdateContactRole(
          c.data.contactFinancialAccountRoleId, {
            sharePercentage: isSuccessorDonor ? 100 : c.percentage,
          })

        result.deletedContactRoleIds = await Promise.all(contactsToDelete.map(deleteContactHandler))
        result.newContactRoles = await Promise.all(newadHocContacts.map(addContactHandler))
        result.updatedContactRoles = await Promise.all(contactsToUpdate.map(updateContactHandler))
      }

      const financialAccount = await updateAccount()

      this.setState({ isLoadingPage: false })

      return {
        ...result,
        financialAccount,
      }
    }

    render () {
      const {
        hide,
        formName,
        isLoading,
        upperTitle,
        description,
        contacts,
        contactType,
        sectionTitle,
        financialAccountType,
        financialAccountId,
        setContacts,
        prevPageInfo,
        maxAdHocContacts,
        adHocContacts,
        initialData,
        goNextSection,
        contactRelationships,
        selfContactId,
        isMobile,
        openModal,
        isSuccessorDonor,
      } = this.props

      const {
        isLoadingPage,
      } = this.state

      const beneficiaryType = allContactTypes.beneficiaries.routeType
      const isBeneficiaryForm = contactType === beneficiaryType

      return (
        <PageContainer
          description={description}
          name={formName}
          upperTitle={upperTitle}
          hide={hide || isLoading}
          isMobile={isMobile}
          isLoading={isLoading}
          prevPageInfo={prevPageInfo}>

          {isLoadingPage && <Loader className={styles.PWMLoader} />}

          <FormComponent
            contactType={contactType}
            adHocContacts={adHocContacts}
            isSuccessorDonor={isSuccessorDonor}
            isBeneficiaryForm={isBeneficiaryForm}
            initialData={initialData}
            sectionTitle={sectionTitle}
            setData={setContacts}
            submitForm={this.submitForm}
            successHandler={this.onSuccess}
            financialAccountType={financialAccountType}
            financialAccountId={financialAccountId}
            maxAdHocContacts={maxAdHocContacts}
            contacts={contacts}
            contactRelationships={contactRelationships}
            goNextSection={goNextSection}
            selfContactId={selfContactId}
            openModal={openModal}
            onAddContact={this.handleOnAddContact}
            onCreateContact={this.handleOnCreateContact}
            onDeleteContact={this.handleOnDeleteContact} />

        </PageContainer>
      )
    }

  }

  return ContactForm
}

export default withContactIndexForm



// WEBPACK FOOTER //
// ./src/components/Onboarding/Accounts/ContactIndexForm/withContactIndexForm.jsx